/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Alessio Pani <alessio.pani@opensoftdev.com>
 */

define(['jquery'], function($) {
    return function() {
        const $mainBanner = $('.main-banner');

        if (!$mainBanner.hasClass('no-link') && $mainBanner.data('link')) {
            $mainBanner.click(function() {
                window.location = $(this).data('link');
            });
        }
    };
});
